import {UserPreferencesService} from '@app/service/user-preferences.service';
import {menuConModalidad} from '@app/utils/menu-modalidad-venta';
import {APP_DOWNLOAD_LINKS} from './app-download-links';
import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {Store} from '@ngxs/store';
import {SesionState} from '@app/state/sesion/sesion.state';
import {Subject} from 'rxjs';
import {distinctUntilChanged, takeUntil} from 'rxjs/operators';
import { AppMainComponent } from './app.main.component';
import {environment} from '@env/environment';
import {menuOpciones} from './menu.opciones';
import {ConfigCompany} from '@app/domain/config-company';
import {MARCA} from '@app/config/plantilla';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss'],
    standalone: false
})
export class AppMenuComponent implements OnInit, OnDestroy {
    readonly marca = MARCA;
    private stopped$ = new Subject<void>();
    private configCompany: ConfigCompany;

    readonly appDownloadLinks = APP_DOWNLOAD_LINKS;
    model: any[];
    urlImageLogo: string;

    // tslint:disable-next-line:variable-name
    private _roles: any[];
    get roles() {
        return this._roles;
    }

    @Input()
    set roles(roles: any[]) {
        this._roles = roles;
        this.loadMenu();
    }

    constructor(public appMain: AppMainComponent, private store: Store, private preferences: UserPreferencesService) {}

    ngOnInit() {
        this.preferences.changes$.pipe(
            distinctUntilChanged((a, b) => a.saleMode === b.saleMode), takeUntil(this.stopped$)).subscribe(() => this.loadMenu());
        void this.preferences.load().catch(() => undefined);
        this.store.select(SesionState.getConfig).pipe(takeUntil(this.stopped$)).subscribe(config => {
            this.configCompany = config; this.loadMenu();
        });
        this.urlImageLogo = environment.urlLogo;
    }

    loadMenu() {
        if (this.roles) {
            const personalMenu = menuConModalidad(menuOpciones, this.preferences.saleMode);
            personalMenu.forEach(mit => {
                this.iterateMenu(mit);
            });
            this.model = personalMenu;
        } else { this.model = []; }
    }

    iterateMenu(item: any) {
        let visible = false;
        const rolesRequired = [...item.rol];
        rolesRequired.forEach(rr => {
            if (this.roles.find(r => r === rr)) {
                visible = true;
            }
        });

        item.visible = visible && (!item.requiresReturnableContainers ||
            (this.configCompany?.permitirRetornoEnvase && this.configCompany?.inventario));
        if (item.items) {
            item.items.forEach(it => {
                this.iterateMenu(it);
            });
        }
    }

    onMenuClick() {
        this.appMain.menuClick = true;
    }
    ngOnDestroy(): void { this.stopped$.next(); this.stopped$.complete(); }
}
